import { APICallV3Post } from 'reactApp/api/APICall';

export class ViewVKArchiveItemDownloadAPICall extends APICallV3Post {
    _method = 'unzip/embedded/get/';
}
